module.exports = "<nv-react-component component=\"BookmarksPanel\" style=\"height: 100%\"></nv-react-component>";